// API configuration for Render backend
// ✅ UPDATED WITH YOUR ACTUAL RENDER URL
const RENDER_BACKEND_URL = "https://hyperlogic-chatbot.onrender.com";
const DEV_BACKEND_URL = "http://localhost:3000";

export const getApiBaseUrl = () => {
  // Check if we're in development mode
  const isDevelopment = import.meta.env.DEV;

  // Use local backend in development, Render backend in production
  return isDevelopment ? DEV_BACKEND_URL : RENDER_BACKEND_URL;
};

// Helper function to handle API responses with proper error handling
export const handleApiResponse = async (response) => {
  const responseText = await response.text();

  if (!responseText) {
    throw new Error("Empty response from server");
  }

  let data;
  try {
    data = JSON.parse(responseText);
  } catch (error) {
    console.error("Failed to parse JSON response:", responseText);
    throw new Error("Invalid JSON response from server");
  }

  if (!response.ok) {
    throw new Error(data.error || `HTTP error! status: ${response.status}`);
  }

  return data;
};

// Helper function to get auth token
export const getAuthToken = () => {
  return localStorage.getItem("auth_token");
};

// Helper function to make authenticated API calls
export const makeApiCall = async (endpoint, options = {}) => {
  const baseUrl = getApiBaseUrl();
  const token = getAuthToken();

  const defaultHeaders = {
    "Content-Type": "application/json",
  };

  if (token) {
    defaultHeaders.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${baseUrl}${endpoint}`, {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  });

  return handleApiResponse(response);
};
